import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Breadcrumb } from "react-bootstrap";
import { getFormById } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Common/extra/loading";
import { useParams } from "react-router-dom";

const ViewOnlineFormIndex = () => {
  const { editId } = useParams();
  const dispatch = useDispatch();
  const [data, setData] = useState({
    name: "",
    documents: [],
    template_categories_id: "",
    template_categories_name: "",
  });
  const [isLoading, setLoading] = useState(false);
  const MessageData = useSelector((s) => s.Signatures?.form?.data);

  useEffect(() => {
    dispatch(getFormById(editId));
  }, [editId]);
  return (
    <>
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item href="/contact-messages">
                    Online Form
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>Details</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
          </Row>
          <div className="bg-white px-4 py-3 card-box">
            {/* <Row>
              <Col lg="6" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  First Name
                </label>
                <input
                  type="text"
                  value={MessageData?.firstname}
                  className="form-control text-capitalize"
                  disabled
                />
              </Col>
              <Col lg="6" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  last Name
                </label>
                <input
                  type="text"
                  value={MessageData?.lastname}
                  className="form-control text-capitalize"
                  disabled
                />
              </Col>
            </Row> */}
            <Row>
              <Col lg="6" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  Email
                </label>
                <input
                  type="text"
                  value={MessageData?.email}
                  className="form-control"
                  disabled
                />
              </Col>
              {/* <Col lg="6" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  Phone
                </label>
                <input
                  type="text"
                  value={MessageData?.phone}
                  className="form-control text-capitalize"
                  disabled
                />
              </Col> */}
            </Row>
            {/* <div className="top my-3">
              <h4 className="dashboard-head m-0">Message</h4>
            </div>
            <Row className="radio-wrp mt-3">
              <textarea
                className="form-control"
                value={MessageData?.message}
                cols="20"
                rows="7"
                disabled
              ></textarea>
            </Row> */}
          </div>
        </Container>
      </section>
    </>
  );
};
export default ViewOnlineFormIndex;
